import { Box } from '@factorialco/deprecated-design-system'
import { PlannedBreakFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import BreakInformation from 'modules/time_planning/components/Breaks/BreakInformation'

interface Props {
  plannedBreaks: PlannedBreakFragment[]
}

const ShiftConfigRowBreaks = ({ plannedBreaks }: Props) => {
  return (
    <Box flexDirection="column" gap="s8">
      {plannedBreaks.map((plannedBreak) => (
        <Box key={plannedBreak.id} flexDirection="row" alignItems="center">
          <BreakInformation plannedBreak={plannedBreak} />
        </Box>
      ))}
    </Box>
  )
}

export default observer(ShiftConfigRowBreaks)
